import { Route, Redirect } from 'react-router-dom';

import { user } from 'services';

/**
 * public route
 *
 * @param {*} param0
 */
export const RoutePublic = ({ component: Component, defaultPath, ...rest }) => {
  if (user.isLogined) {
    return <Redirect to={defaultPath} />;
  } else {
    return <Route {...rest} render={(props) => <Component {...props} />} />;
  }
};
